module.exports = __webpack_public_path__ + "img/950480b987a1ad8cceafc6b17be4aec9.png";